import { render } from "./ForKknife.vue?vue&type=template&id=7d778ec8"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ForKknife.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d778ec8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d778ec8', __exports__)) {
    api.reload('7d778ec8', __exports__)
  }
  
  module.hot.accept("./ForKknife.vue?vue&type=template&id=7d778ec8", () => {
    api.rerender('7d778ec8', render)
  })

}


export default __exports__